import React from 'react';
import { Button } from 'reactstrap';

export default ({ isLoading, text, loadingText, className = '', disabled = false, ...props }) => (
	<Button className={`LoaderButton ${className}`} disabled={disabled || isLoading} {...props}>
		{isLoading && <i className="fas fa-sync-alt fa-spin mr-2" />}
		{!isLoading ? text : loadingText}
	</Button>
);
